import AdminAlertSettingsPage from '../../../components/admin/settings/AdminAlertSettingsPage'

export default function SettingsAlertSettings() {
  return <AdminAlertSettingsPage />
}
